import { sendEvents } from '@fiverr-private/futile';
import { bigQuery } from '@fiverr-private/obs';

declare global {
    interface Window {
        Fiverr?: {
            sendClientEvents: (event: any) => void;
        };
    }
}

const getBigQueryData = (linkKey: string, headerType: string | null = null) => ({
    group: 'header_clicks',
    type: `clicked_header.${linkKey}`,
    header_type: headerType,
});

export const reportBigQuery = (linkKey: string, headerType: string | null = null) => {
    const event = getBigQueryData(linkKey, headerType);

    if (typeof window.Fiverr === 'object' && typeof window.Fiverr.sendClientEvents === 'function') {
        sendEvents(event);
    } else {
        bigQuery.send(event);
    }
};
